import { Badge } from '@workspace/ui/components/badge'

/**
 * Short labels so a row of badges fits a narrow table column. The full
 * "key: arm" sits on the badge title, since the key is what the analysis
 * actually groups by.
 */
const EXPERIMENT_SHORT_LABELS: Record<string, string> = {
  engagement_v1: 'eng',
  type_boost_v1: 'type',
}

interface ExperimentArmBadgesProps {
  arms: Record<string, string> | null | undefined
  /** Render the full experiment key rather than the short label. */
  verbose?: boolean
}

/**
 * A founder's matcher experiment arms.
 *
 * Renders nothing but an em dash when there are no arms. That state is "not
 * enrolled", which is deliberately distinct from "control": enrolment happens
 * when a founder's outreach queue first flushes, so a startup that has never
 * started outreach has none, and counting those as control would bias the split.
 */
export function ExperimentArmBadges({ arms, verbose = false }: ExperimentArmBadgesProps) {
  if (!arms || Object.keys(arms).length === 0) {
    return <span className="text-muted-foreground text-sm">Not enrolled</span>
  }

  return (
    <div className="flex flex-wrap gap-1">
      {Object.entries(arms)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([key, arm]) => (
          <Badge
            key={key}
            variant={arm === 'control' ? 'outline' : 'default'}
            title={`${key}: ${arm}`}
          >
            {verbose ? key : (EXPERIMENT_SHORT_LABELS[key] ?? key)}
            {verbose ? `: ${arm}` : arm === 'control' ? '' : '✓'}
          </Badge>
        ))}
    </div>
  )
}
